/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $('#footer-contact').click(function() {
          $(this).addClass('open')
        });

        // Global viriables
        var flag = false;
        var timey = null;
        var price = null;
        var location = null;
        var element = [];
        var total = 0;

        // Page products
        if (window.location.hash) {
          var hash = window.location.hash.substring(1);  // removes the #
          if (hash === 'tirage') {
            $('div').filter('.product-cat-tirages').removeClass('not-selected');
            $('div').filter('.product-cat-objets').addClass('not-selected');
            // En
            $('div').filter('.product-cat-things').removeClass('not-selected');
            $('div').filter('.product-cat-prints').addClass('not-selected');
          } else if (hash === 'objet') {
            $('div').filter('.product-cat-objets').removeClass('not-selected');
            $('div').filter('.product-cat-tirages').addClass('not-selected');
            // En
            $('div').filter('.product-cat-things').removeClass('not-selected');
            $('div').filter('.product-cat-prints').addClass('not-selected');
          }
        }

        $('#filter-product-all').click(function(event) {
          event.preventDefault();
          $('div').filter('.product-cat-objets').removeClass('not-selected');
          $('div').filter('.product-cat-tirages').removeClass('not-selected');
          // En
          $('div').filter('.product-cat-things').removeClass('not-selected');
          $('div').filter('.product-cat-prints').removeClass('not-selected');
        });

        $('#filter-product-objets').click(function(event) {
          event.preventDefault();
          $('div').filter('.product-cat-objets').removeClass('not-selected');
          $('div').filter('.product-cat-tirages').addClass('not-selected');
          // En
          $('div').filter('.product-cat-things').removeClass('not-selected');
          $('div').filter('.product-cat-prints').addClass('not-selected');
        });

        $('#filter-product-tirages').click(function(event) {
          event.preventDefault();
          $('div').filter('.product-cat-tirages').removeClass('not-selected');
          $('div').filter('.product-cat-objets').addClass('not-selected');
          //En
          $('div').filter('.product-cat-prints').removeClass('not-selected');
          $('div').filter('.product-cat-things').addClass('not-selected');
        });

        // Update dynamically price
        function update_price() {
          var items = jQuery( document ).find('#shop-cart .Cart-item');
          total = 0;
          totalQt = 0;

          // loop all items
          items.each(function( index, e ) {
            var qt = ($(this).find('.quantity input').attr('value') > 15) ? 15 : $(this).find('.quantity input').attr('value');
            $(this).find('.quantity input').val(qt);
            totalQt += parseInt(qt);
            total += $(this).find('.product-price').attr('data-price') * qt;
          });

          // Update header menu number of items
          $('#nb-items-header').html(totalQt);
          $('.order-total span.amount').html(total.toFixed(2) + '€');
        }

        // update price on lunch site
        update_price();

        // Change qty on input text value
        $( document ).on( 'keypress', '.product-quantity', function(e) {
          setTimeout(function(){
            update_price();

            var qt = ($(this).find('.quantity input').attr('value') > 15) ? 15 : $(this).find('.quantity input').attr('value');
            var id = $(this).parent().find('.Spinner').attr('data-productid');

            $(this).find('.quantity input').val(qt);
            jQuery.ajax({
              type: 'POST',
              url: '/shop?qty=' + qt + '&product_id=' + id,
              success: function(response, textStatus, jqXHR){}
            });

          }.bind(this), 1000);
        });

        // open menu and update price on click to 'add to cart' button
        $( document ).on( 'click', '.add_to_cart_button', function(e) {
          e.preventDefault();

          if (!$(this).hasClass('button product_type_simple added')) {
            $('.Spinner[data-productid=' + $(this).attr('data-product_id') + ']').find(".Spinner-up" ).trigger( "click" );
          }

          // Supprime les class pour empecher l'ajac de se declencher
          $(this).removeClass('button product_type_simple added');

          // it update price
          setTimeout(function(){
            update_price();
          },1300);

          $('body').addClass('no-scroll');
          $('.CartSidebar').addClass('is-open');
        });

        // Change quantity
        $( document ).on( 'click', '.Spinner-controls span', function(e) {
          e.preventDefault();
          flag = true;
          total = 0;
          element = $(e.target);
          whiler(element);
          handle_input(element, true);
        });

        function handle_input(element, on) {
            if (on){
              element.addClass('modding');
            } else {
              element.removeClass('modding');
            }
        }

        // Update qty
        function whiler(guy) {
          var elQty = guy.parent().parent().parent();
          var p_id = elQty.parent().find('.Spinner').attr('data-productid');

          if (guy.hasClass('Spinner-up') && parseInt(elQty.find('.qty').val()) >= 0 && parseInt(elQty.find('.qty').val()) < 15){
            elQty.find('.qty').val(parseInt(elQty.find('.qty').val()) + 1);
          } else if (guy.hasClass('Spinner-dn') &&  parseInt(elQty.find('.qty').val()) > 0 && parseInt(elQty.find('.qty').val()) <= 15){
            elQty.find('.qty').val(parseInt(elQty.find('.qty').val()) - 1);
          }

          var new_qty = elQty.find('.qty').val();

          // Remove item from cart if quantity is equal to 0.
          if (parseInt(new_qty) === 0) {
            elQty.find('.qty').closest('.Cart-item').remove();
          }

          // Update cart
          jQuery.ajax({
            type: 'POST',
            url: '/shop?qty=' + new_qty + '&product_id=' + p_id,
            success: function(response, textStatus, jqXHR){}
          });

          update_price();
        }

        // Menu
        $('#toggle-nav').click(function(e){
          e.preventDefault();
          if($('#toggle-nav').hasClass('is-close')) {
            $('#toggle-nav').removeClass('is-close');
            $('#nav-wrapper').removeClass('is-hidden');
          } else {
            $('#toggle-nav').addClass('is-close');
            $('#nav-wrapper').addClass('is-hidden');
          }
        });

        if($( window ).width()<800) {
          $('#toggle-nav').addClass('is-close');
          $('#nav-wrapper').addClass('is-hidden');
        }

        // Close menu on scroll
        $(window).scroll(function(){
          var height = $(window).scrollTop();
          if(height  > 50) {
            $('#toggle-nav').addClass('is-close');
            $('#nav-wrapper').addClass('is-hidden');
          } else {
            $('#toggle-nav').removeClass('is-close');
            $('#nav-wrapper').removeClass('is-hidden');
          }
        });

        // Sidebar
        //

        $('#toggle-sidebar-cart').click(function(){
          if($('.CartSidebar').hasClass('is-open')) {
            $('body').removeClass('no-scroll');
            $('.CartSidebar').removeClass('is-open');
            $('.Nav-cart').removeClass('is-active');
          } else {
            $('body').addClass('no-scroll');
            $('.CartSidebar').addClass('is-open');
            $('.Nav-cart').addClass('is-active');
            //$('.Page').addClass('is-translate');
          }
        });

        $('#close-sidebar-cart').click(function(){
          $('body').removeClass('no-scroll');
          $('.CartSidebar').removeClass('is-open');
          $('.Nav-cart').removeClass('is-active');
          //$('.Page').removeClass('is-translate');
        });
        // Carousel
        //

        // Space between slide
        var slideSpace = '';

        function calcSlideSpace() {
          slideSpace = $(window).width() * 0.19;
        }

        // Swiper
        function carousel() {
          var mySwiper = new Swiper ('.swiper-container', {
            speed: 800,
            pagination: '.swiper-pagination',
            slidesPerView: 'auto',
            centeredSlides: true,
            paginationClickable: true,
            spaceBetween: slideSpace,

            // Navigation arrows
            nextButton: '.Carousel-buttonNext',
            prevButton: '.Carousel-buttonPrev',
            paginationBulletRender: function (index, className) {
                return '<span class="Carousel-pagination-number ' + className + '">' + (index + 1) + '</span>';
            }
          });
        }

        if($( window ).width()>800) {
          calcSlideSpace();
          carousel();

          $(window).resize(function() {
            calcSlideSpace();
            carousel();
          });
        }


        // browser window scroll (in pixels) after which the "back to top" link is shown
      	var offset = 300,
      		//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
      		offset_opacity = 1200,
      		//duration of the top scrolling animation (in ms)
      		scroll_top_duration = 700,
      		//grab the "back to top" link
      		$back_to_top = $('.cd-top');

      	//hide or show the "back to top" link
      	$(window).scroll(function(){
      		( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
      		if( $(this).scrollTop() > offset_opacity ) {
      			$back_to_top.addClass('cd-fade-out');
      		}
      	});

      	//smooth scroll to top
      	$back_to_top.on('click', function(event){
      		event.preventDefault();
      		$('body,html').animate({
      			scrollTop: 0 ,
      		 	}, scroll_top_duration
      		);
      	});

      (function () {
             	     $( '.icon-menu' ).click(function(){
          	     $('#menu').toggleClass('expand')
          	     })


          function resizeVideo(){
              var $video = $('.tumblr_video_container');

              var videoWidth = $video.width(),
                  videoHeight = $video.height(),
                  videoRatio = (videoHeight/videoWidth),

                  newWidth = 560,
                  newHeight = Math.floor(newWidth*videoRatio),

                  mobileWidth = 260,
                  mobileHeight = Math.floor(mobileWidth*videoRatio);

              if ($(window).width() < 640) {
                  $video.css('width', '100%').css('height', mobileHeight);
                  $video.find('iframe').height(mobileHeight);
              }
              else {
                  $video.css('width', '100%').css('height', newHeight);
                  $video.find('iframe').height(newHeight);
              }

              $(window).resize(function() {
                  if ($(window).width() < 640) {
                      $video.css('width', '100%').css('height', mobileHeight);
                  }
                  else {
                      $video.css('width', '100%').css('height', newHeight);
                  }
              });
          }
          resizeVideo();

          var $load_style = "automatic";
          var $tumblelog = $('#posts');
          var $fade = $('.fade, .navigation, .notes');

          $tumblelog.infinitescroll( {
            debug: true,
            loading: {
                img: 'data:image/gif;base64,R0lGODlhAQABAHAAACH5BAUAAAAALAAAAAABAAEAAAICRAEAOw==',
                finished: undefined,
                finishedMsg: '',
                msg: null,
                msgText: '',
                speed: 'fast',
                start: undefined
            },
            state: {
                currPage: 1
            },
            navSelector: ".navigation",
            nextSelector: ".navigation a",
            itemSelector: ".post",
            errorCallback: function (selector, msg) {
                $('.load-more').animate({
                    opacity: 0
                });
            }
        },
          function (newElements) {
              var $newElems = $(newElements).css({
                  opacity: 0
              });
              $newElems.imagesLoaded(function () {
                  $newElems.animate({
                      opacity: 1
                  }).fadeIn().removeClass('fade');

                  $tumblelog.masonry('appended', $newElems);

                  $(".post").hover(function() {
                      $(this).find('img').stop().animate({"opacity": "0.4"}, 300);
                  }, function() {
                      $(this).find('img').stop().animate({"opacity": "1"}, 300);
                  });

              });

              $('body').find('a[data-rel^=lightcase]').lightcase({
                overlayOpacity: 1,
                speedIn: 600,
                speedOut: 500,
                maxHeight: 99999999999,
                maxWidth: 780,
                forceWidth: true,
                forceHeight: true,
                liveResize: false
              });
          });
          $tumblelog.imagesLoaded(function () {
              $fade.each(function(i) {
                  $(this).delay(110*i).fadeIn();
              });

              $tumblelog.masonry({
                  columnWidth: 40,
                  isFitWidth: true,
                  //itemSelector: '.post, #menu',
                  isAnimated: !Modernizr.csstransitions
              });

              setTimeout(function() {
                $fade.each(function(i) {
                  $(this).delay(110*i).css('opacity', '1');
                });
              }, 600);
          });

          if ($load_style == "click" ) {
              $(window).unbind('.infscr');
              $( ".load-more" ).click(function() {
                  $('#posts').infinitescroll('retrieve');
                  return false;
              });
          }
          else {
              $('.load-more').remove();
          }

          $(".post").hover(function() {
              $(this).find('img').stop().animate({"opacity": "0.4"}, 300);
          }, function() {
              $(this).find('img').stop().animate({"opacity": "1"}, 300);
          });

          $(".post").hover(function() {
              $(this).find('img').stop().animate({"opacity": "0.4"}, 300);
          }, function() {
              $(this).find('img').stop().animate({"opacity": "1"}, 300);
          });

          $('body').find('a[data-rel^=lightcase]').lightcase({
            overlayOpacity: 1,
            speedIn: 600,
            speedOut: 500
          });

          $('.popup-link').magnificPopup({
            type: 'image',
            removalDelay: 900,

            // Class that is added to popup wrapper and background
            // make it unique to apply your CSS animations just to this exact popup
            mainClass: 'mfp-fade'
          });
        /*----------------------------------------------
        	H I D E   P A G E   L O A D E R  + S M O O T H   S H O W
        ------------------------------------------------*/
        jQuery("#page-loader .page-loader-inner").delay(500).fadeIn(10, function(){
          jQuery(this).fadeOut(500,function() {
          	jQuery("#page-loader").fadeOut(500);
          });
        });
      })();


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on home page

        $('#scroll-down-home').click(function(){

        });
        if($( window ).width()>800) {
          $('#fullpage').fullpage({
            //Navigation
            menu: false,
            lockAnchors: false,
            navigation: false,
            showActiveTooltip: false,
            slidesNavigation: true,
            slidesNavPosition: 'bottom',

            //Scrolling
            css3: true,
            scrollingSpeed: 1000,
            autoScrolling: true,
            fitToSection: true,
            fitToSectionDelay: 1000,
            scrollBar: false,
            easing: 'easeInOutCubic',
            easingcss3: 'ease',
            loopBottom: true,
            loopTop: false,
            loopHorizontal: true,
            continuousVertical: false,
            scrollOverflow: false,
            touchSensitivity: 15,
            normalScrollElementTouchThreshold: 5,

            //Accessibility
            keyboardScrolling: true,
            animateAnchor: true,
            recordHistory: true,

            //Design
            controlArrows: false,
            verticalCentered: false,
            resize: true,
            responsiveWidth: 0,
            responsiveHeight: 0,

            //Custom selectors
            sectionSelector: '.Home-section',
            slideSelector: '.slide',

            //events
            onLeave: function(index, nextIndex, direction) {
              //first slide of the second section
              if(index === 1){
                $('#nav-wrapper').addClass('is-hidden');
                $('#toggle-nav').addClass('is-close');
                $('#header').removeClass('Header--homeFirstSlide');
              }
            },
            afterLoad: function(anchorLink, index) {
              if(index === 1){
                $('#nav-wrapper').removeClass('is-hidden');
                $('#toggle-nav').removeClass('is-close');
                $('#header').addClass('Header--homeFirstSlide');
              }
            },
            afterRender: function() {},
            afterResize: function() {},
            afterSlideLoad: function(anchorLink, index, slideAnchor, slideIndex) {},
            onSlideLeave: function(anchorLink, index, slideIndex, direction, nextSlideIndex) {},
          });
        }
        // Home page image
        function windowHeight() {
          var winHeight = $(window).height() - 100;
          $('#hero-background-image').css('height', winHeight);
        }
        if($( window ).width()>800) {
          windowHeight();

          $(window).resize(function() {
            windowHeight();
          });
        }
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'found': {
      init: function() {
        // JavaScript to be fired on the found page

      },
      finalize: function() {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
jQuery(window).on('load', function() {

});
